<template>
  <section>
    <div class="container">
      <div class="hero">
        <div class="hero-head">
          <Header/>
        </div>
        <div class="hero-body">
          <router-view/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import Header from "@/components/Layout/Header"

  export default {
    components: {Header},
    name: "Layout",
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>